import React, { useEffect, useState } from 'react';
import { Table, Button, Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { MdAddCircle, MdManageAccounts } from 'react-icons/md';
import axios from 'utils/axios';
import { useTranslation } from 'react-i18next'; // i18n hook

const RoleList = () => {
  const { t } = useTranslation(); // initialize translation
  const [roles, setRoles] = useState([]);
  const [totalItems, setTotalItems] = useState(50);
  const [loading, setLoading] = useState(true);
  const [pagination, setPagination] = useState({ page: 1, rowsPerPage: 10 });
  const navigate = useNavigate();

  useEffect(() => {
    fetchRoles();
  }, [pagination]);

  const fetchRoles = async () => {
    setLoading(true);
    try {
      const response = await axios.get('users/role');
      const data = response.data;
      setRoles(data.items);
      setTotalItems(data.total);
    } catch (error) {
      console.error('Error fetching roles:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleManageClaims = (roleId, roleName) => {
    navigate(`/role/claims/${roleId}?name=${roleName}`);
  };

  const totalPages = Math.ceil(totalItems / pagination.rowsPerPage);

  const handlePageChange = (pageNumber) => {
    setPagination((prev) => ({ ...prev, page: pageNumber }));
  };

  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2>{t('role_list')}</h2>
        <Button variant="primary" onClick={() => navigate('/addrole')}>
          <MdAddCircle className="me-2" size={20} />
          {t('add_role')}
        </Button>
      </div>

      {loading ? (
        <div className="text-center my-4">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : roles.length === 0 ? (
        <p>{t('no_roles_available')}</p>
      ) : (
        <table className="table w-full text-sm text-left border-collapse">
        <thead className="border-b">
          <tr>
            <th>{t('role_name')}</th>
            <th className="text-end pl-4">{t('actions')}</th> {/* Header stays left aligned */}
          </tr>
        </thead>
        <tbody>
          {roles.map((role) => (
            <tr key={role.id} className="border-b hover:bg-gray-50">
              <td>{role.role}</td>
              <td className="text-end"> {/* Align button to right */}
                <div className="inline-flex">
                <Button
                    variant="outline-secondary"
                    size="sm"
                    onClick={() => handleManageClaims(role.id, role.role)}
                  >
                    <MdManageAccounts className="me-1" size={16} />
                    {t('manage_claims')}
                  </Button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      
      


      )}
    </div>
  );

};

export default RoleList;
